export default {"src":"/_next/static/media/ra-warning-alert.dbdae989.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};